import axios from 'axios';
import authHeader from "@/service/auth-header";

class PractitionerService {

    getCompanyPractitioners(companyId) {
        console.log("[PractitionerService][getCompanyPractitioners] Before getting practitioners. Company ID = ", companyId);
        return axios.get(`/api/practitioner/${companyId}`, {headers: authHeader()})
    }

    searchCompanyPractitioners(companyId, searchCriteria) {
        console.log("[PractitionerService][getCompanyPractitioners] Before getting practitioners. Company ID = ", companyId);
        return axios.get(`/api/practitioner/${companyId}/${searchCriteria}`, {headers: authHeader()})
    }

    getPractitioner(practitionerId) {
        console.log("[PractitionerService][getCompanyPractitioners] Before getting practitioners. Practitioner ID = ", practitionerId);
        return axios.get(`/api/practitioner/specific/${practitionerId}`, {headers: authHeader()})
    }

    createPractitioner(companyId, data) {
        console.log("[PractitionerService][createPractitioner] Before creating practitioner back-end API call. Data = ", data);
        return axios.post(`/api/practitioner/${companyId}`, data, {headers: authHeader()});
    }

    updatePractitioner(practitionerId, data) {
        console.log("[PractitionerService][updatePractitioner] Before updating practitioner back-end API call. Data = ", data);
        return axios.put(`/api/practitioner/${practitionerId}`, data, {headers: authHeader()});
    }

    deletePractitioner(practitionerId) {
        console.log("[PractitionerService][deletePractitioner] Before deleting practitioner. Practitioner ID = ", practitionerId);
        return axios.delete(`/api/practitioner/${practitionerId}`, {headers: authHeader()});
    }

}

export default new PractitionerService();
